module.exports = __webpack_public_path__ + "static/media/dinosaur(19).888e37fa.PNG";